<script setup lang="ts">
  import { useRoute } from 'vue-router'
  import { useAuthStore } from '@/stores/auth'

  const authStore = useAuthStore()
  const route = useRoute()
</script>

<template>
  <div>
    <div
      v-if="!['shop order create', 'shop order detail'].includes(String(route.name))"
      class="fixed inset-x-0 bottom-0">
      <div class="grid grid-cols-5 max-w-2xl rounded-t-md bg-white pb-2 container">
        <app-button
          class="sidebar-link"
          :to="{name: 'home'}">
          <div><fa-icon icon="i-far-house" /></div>
          <div class="text-xs">
            Home
          </div>
        </app-button>

        <app-button
          v-if="authStore.canAccess('mengakses produk')"
          class="sidebar-link"
          :to="{name: 'product list'}">
          <div><fa-icon icon="i-far-box" /></div>
          <div class="text-xs">
            Produk
          </div>
        </app-button>

        <app-button
          v-if="authStore.canAccess('membuat pesanan')"
          class="sidebar-link"
          :to="{name: 'shop order create'}">
          <div><fa-icon icon="i-far-cart-plus" /></div>
          <div class="text-xs">
            Buat
          </div>
        </app-button>

        <app-button
          v-if="authStore.canAccess('mengakses pesanan')"
          :to="{name: 'shop order list'}"
          class="sidebar-link">
          <div><fa-icon icon="i-far-receipt" /></div>
          <div class="text-xs">
            Pesanan
          </div>
        </app-button>

        <app-button
          v-if="authStore.canAccess('mengakses customer')"
          class="sidebar-link"
          :to="{name: 'customer list'}">
          <div><fa-icon icon="i-far-users" /></div>
          <div class="text-xs">
            Pembeli
          </div>
        </app-button>
      </div>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
  :deep() {
    .sidebar-link {
      @apply pt-2 text-center w-16 w-full;
    }

    .router-link-exact-active {
      @apply text-primary font-medium;
    }
  }
</style>
